import React from 'react';
import { Icon, Popconfirm } from 'antd'
const  moment = require('moment');

class ProjectCard extends React.Component {

  getCircleStyle = (index) => {
    let borderColor = this.props.color
    const currentPhase = this.props.data && this.props.data.current_phase
    let stageIndex = 6
    switch(currentPhase) {
      case 'Investigation':
        stageIndex = 1
        break;
      case 'Preparation':
        stageIndex = 2
        break;
      case 'Action':
        stageIndex = 3
        break;
      case 'Reflection':
        stageIndex = 4
        break;
      case 'Demonstration':
        stageIndex = 5
        break;
    }

    let color;
    if (stageIndex < index ) {
      color = '#626262'
    } else if (stageIndex == index) {
      color = '#E19F48'
    } else if (stageIndex == 6) {
      color = '#52B397'
    } else {
      color = '#52B397'
    }

    return {
      height: 50,
      width: 50,
      borderRadius: '50%',
      border: `4px solid ${borderColor}`,
      backgroundColor: color,
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 20,
      zIndex: 1
    }
  }

  render() {

    const { data, color, t } = this.props


    const styles = {
      box: {
        backgroundColor: 'white',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
        borderRadius: 10,
        padding: 20,
        height: 210
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 16,
        marginBottom: 0
      },
      phase: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 14,
        marginBottom: 0,
        marginRight: 15
      },
      entry: {
        fontFamily: 'Helvetica Neue',
        color: color,
        fontSize: 14
      },
      date: {
        padding: '0px 20px',
        backgroundColor: color,
        borderRadius: 10,
        color: 'white',
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 12,
        position: 'absolute',
        right: 30,
        top: 30
      },
      deleteIcon: {
        position: 'absolute',
        right: 30,
        bottom: 30,
        fontSize: 26,
        color: color
      },
      editIcon: {
        position: 'absolute',
        right: 70,
        bottom: 30,
        fontSize: 26,
        color: color
      },
      editIcon: {
        position: 'absolute',
        right: 35,
        fontSize: 20,
        top: 30,
        color: color,
        cursor: 'pointer'
      },
      exportIcon: {
        position: 'absolute',
        right: 65,
        fontSize: 20,
        top: 30,
        color: color,
        cursor: 'pointer'
      }
    }

    return (
      <div id='logBox' style={styles.box}>
        <div>
          <Icon onClick={() => this.props.editTitle()} style={styles.editIcon} type="edit" />
          <Icon onClick={() => this.props.export()} style={styles.exportIcon} type="file-pdf" />
          <div onClick={() => this.props.edit()} style={{cursor: 'pointer'}}>
            <h3 style={styles.title}>{data.projectTitle}</h3>
            <p style={styles.entry}>{data.projectDescription && data.projectDescription.substring(0, 110)}</p>
            <div style={{display: 'inline-flex'}}>
              <h3 style={styles.phase}>{t('Current Phase')}:</h3>
              <p style={styles.entry}>{data.current_phase ? data.current_phase : t('Completed')}</p>
            </div>
            <div style={{position: 'relative', top: 35, backgroundColor: '#0a4c62', width: '100%', height: 2}}/>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 10, }}>
              <div style={this.getCircleStyle(1)}>1</div>
              <div style={this.getCircleStyle(2)}>2</div>
              <div style={this.getCircleStyle(3)}>3</div>
              <div style={this.getCircleStyle(4)}>4</div>
              <div style={this.getCircleStyle(5)}>5</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/ProjectCard/index.jsx